module.exports = __webpack_public_path__ + "media/images/plans/photo_studio/point-2-2-54ff97aca1fc288090484201c4784fb8.jpg";